import React, { useRef, useState, useEffect } from "react";
import css from "./main.module.css";
import filter from "../../img/bar-chart.svg";
import barChartGif from "../../img/bar-chart-gif.gif";
import filterAnima from "../../img/wired-outline-19-magnifier-zoom-search-hover-spin.gif";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { getLanguageLevels } from "../../lib/getLanguageLevels";
const AllTems = ({
  categories,
  onCategoryClick,
  selectedCategory,
  onLevelFilter,
  languageLevels,
  selectedLevel,
  setSelectedLevel,
  allLevels,
  onClearAllFilters,
  scrollTick
}) => {
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedLevelGroup, setSelectedLevelGroup] = useState("all");
  const scrollContainerRef = useRef(null);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const { t } = useTranslation();
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);
  const levelMapping = {
    A1: t("levelonea"),
    A2: t("leveltwoa"),
    B1: t("levevoneb"),
    B2: t("lebeltwob"),
    C1: t("levelonec"),
    C2: t("leveltwoc"),
  };

  // simplified level groups
  const levelGroups = {
    beginner: {
      label: t("levelBeginnerGroup"),
      levels: ["A1", "A2"],
    },
    intermediate: {
      label: t("levelIntermediateGroup"),
      levels: ["B1", "B2"],
    },
    advanced: {
      label: t("levelAdvancedGroup"),
      levels: ["C1", "C2"],
    },
  };

  const parentCategories = categories.filter(
    (category) => category.parent === null
  );
  const sortedCategories = [
    ...parentCategories.filter((cat) => selectedCategoryIds.includes(cat.id)),
    ...parentCategories.filter((cat) => !selectedCategoryIds.includes(cat.id)),
  ];

  useEffect(() => {
    const storedPurpose = localStorage.getItem("selectedPurpose");
    if (storedPurpose) {
      try {
        const parsed = JSON.parse(storedPurpose);
        if (parsed.categories && Array.isArray(parsed.categories)) {
          setSelectedCategoryIds(parsed.categories);
        }
      } catch (e) {
        console.warn("❌ Failed to parse stored purpose", e);
      }
    }
  }, []);

  useEffect(() => {
    if (showDropdown) {
      setShowDropdown(false);
    }
  }, [scrollTick]); // << triggers when parent scrolls
  

  // sync selectedLevelGroup with actual selected level
  useEffect(() => {
    if (!selectedLevel) {
      setSelectedLevelGroup("all");
      return;
    }

    

    // Find which level group contains the selected level
    const foundGroup = Object.entries(levelGroups).find(([key, group]) => {
      return group.levels.some((levelName) => {
        const matched = allLevels.find((lvl) => lvl.name === levelName);
        return matched && matched.id === selectedLevel;
      });
    });

    if (foundGroup) {
      setSelectedLevelGroup(foundGroup[0]);
    } else {
      setSelectedLevelGroup("all");
    }
  }, [selectedLevel, allLevels]);

  const handleScroll = (direction) => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = container.offsetWidth / 2;
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const checkScrollPosition = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      setCanScrollLeft(container.scrollLeft > 0);
      setCanScrollRight(
        container.scrollLeft + container.offsetWidth < container.scrollWidth
      );
    }
  };

  const handleLevelSelect = (levelKey) => {
    setShowDropdown(false);
    setSelectedLevelGroup(levelKey);

    if (levelKey === "all") {
      // Handle "All levels" selection
      if (typeof setSelectedLevel === "function") {
        setSelectedLevel(null);
      }
      localStorage.removeItem("selectedLevel");
      if (typeof onLevelFilter === "function") {
        onLevelFilter(null);
      }
      return;
    }

    if (levelGroups[levelKey]) {
      // For group selections, pass the group name directly
      if (typeof setSelectedLevel === "function") {
        setSelectedLevel(levelKey);  // Pass the group key (beginner, intermediate, advanced)
      }
      if (typeof onLevelFilter === "function") {
        onLevelFilter(levelKey);  // Pass the group key to the filter handler
      }
      return;
    }

    const matched = allLevels.find((lvl) => lvl.name === levelKey);
    if (matched) {
      localStorage.setItem("selectedLevel", matched.id);
      console.log("matched", matched);

      if (typeof setSelectedLevel === "function") {
        setSelectedLevel(matched.id);
      }

      if (typeof onLevelFilter === "function") {
        onLevelFilter(matched.id);
      }
    }
  };

  const toggleCategory = (categoryId) => {
    let updated;
    if (selectedCategoryIds.includes(categoryId)) {
      updated = selectedCategoryIds.filter((id) => id !== categoryId);
    } else {
      updated = [...selectedCategoryIds, categoryId];
    }
    setSelectedCategoryIds(updated);
    onCategoryClick(categoryId);
  };

  const handleClearAllFilters = () => {
    setSelectedCategoryIds([]);
    setSelectedLevelGroup("all");

    if (typeof setSelectedLevel === "function") {
      setSelectedLevel(null);
    }

    localStorage.removeItem("selectedLevel");
    localStorage.setItem("selectedPurpose", JSON.stringify({ categories: [] }));

    if (typeof onClearAllFilters === "function") {
      onClearAllFilters();
    }
  };

  useEffect(() => {
    if (!showDropdown) return;
  
    const handleWindowScroll = () => {
      setShowDropdown(false);
    };
  
    window.addEventListener('scroll', handleWindowScroll);
  
    return () => {
      window.removeEventListener('scroll', handleWindowScroll);
    };
  }, [showDropdown]);
  

  return (
    <>
      {/* Always show filters at the top */}
        {canScrollLeft && (
          <div
            className={`${css.arrowBlockCat} ${css.leftArrow}`}
            onClick={() => handleScroll("left")}
          >
            <IoIosArrowBack className={css.ioIosArrowBack} />
          </div>
        )}

        <div 
          className={css.wrapAllDe}
          ref={scrollContainerRef}
          onScroll={checkScrollPosition}
        >
          <div ref={anchorRef} className={css.navbarLink} id="catalog_dropdown" onClick={() => {
    if (!showDropdown && anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 5, // push it down a bit
        left: rect.left,
      });
    }
    setShowDropdown((prev) => !prev);
  }}>
            <div>
              {!showDropdown ? (
                <img
                  src={filter}
                  className={css.navbarIcon}
                  alt={t("Language level")}
                />
              ) : (
                <img src={barChartGif} className={css.navbarIcon} alt={t("Language level")} />
              )}
            </div>
            <span>{t("Language level")}</span>
            {showDropdown && (
              <div className={css.dropdownMenu2} style={{
                position: "fixed",
                top: `${position.top}px`,
                left: `${position.left}px`,
                zIndex: 1000,
              }}>
                <div
                  key="all"
                  className={`${css.pAllLevelsBegin} ${
                    selectedLevelGroup === "all" ? css.selectedDropdownItem : ""
                  }`}
                  onClick={() => handleLevelSelect("all")}
                >
                  {t("allLevels")}
                </div>
                {Object.entries(levelGroups).map(([key, group]) => (
                  <div
                    key={key}
                    className={`${css.pAllLevelsBegin} ${
                      selectedLevelGroup === key ? css.selectedDropdownItem : ""
                    }`}
                    onClick={() => handleLevelSelect(key)}
                  >
                    {t(group.label)}
                  </div>
                ))}
              </div>
            )
           
           }
           
          </div>
        </div>
      {sortedCategories.map((category) => (
        <div
          key={category.id}
          className={`${css.navbarLink} ${selectedCategory?.includes(category.id) && selectedCategory?.length > 0 ? css.selectedDropdownItem : ''}`}
          onClick={() => toggleCategory(category.id)}
        >
          <img
              className={`${css.navbarIcon}`}
              src={category.icon || "path_to_placeholder_image.png"}
              alt={t(category.name)}
            />
          <span>{t(category.name)}</span>
        </div>
      ))}
    </>
  );
};

export default AllTems;
